// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App-header {
	background-color: var(--third-bg-color);
	height: 10vh;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	font-size: calc(2px + 2vmin);
	color: var(--main-text-color);
	box-shadow: 0 2px 10px rgba(127, 204, 159, 0.1);
	padding: 0 20px;
	position: sticky;
	top: 0;
	z-index: 100;
}

.header-left {
	display: flex;
	align-items: center;
}

.header-right {
	display: flex;
	align-items: center;
	gap: 16px;
}

.logo-link {
	display: flex;
	align-items: center;
	text-decoration: none;
	transition: opacity 0.3s;
}

.logo-link:hover {
	opacity: 0.8;
}

.aegirLogo {
	height: 7vh;
	min-height: 50px;
	max-height: 80px;
	width: auto;
	object-fit: contain;
}

/* Mobile Responsive */
@media (max-width: 768px) {
	.App-header {
		padding: 0 15px;
		height: 8vh;
		min-height: 60px;
	}
	
	.aegirLogo {
		height: 5vh;
		min-height: 40px;
	}
	
	.header-right {
		gap: 12px;
	}
}

@media (max-width: 480px) {
	.App-header {
		padding: 0 10px;
	}
	
	.header-right {
		gap: 8px;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/header/header.css"],"names":[],"mappings":"AAAA;CACC,uCAAuC;CACvC,YAAY;CACZ,aAAa;CACb,mBAAmB;CACnB,mBAAmB;CACnB,8BAA8B;CAC9B,4BAA4B;CAC5B,6BAA6B;CAC7B,+CAA+C;CAC/C,eAAe;CACf,gBAAgB;CAChB,MAAM;CACN,YAAY;AACb;;AAEA;CACC,aAAa;CACb,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,qBAAqB;CACrB,wBAAwB;AACzB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,WAAW;CACX,gBAAgB;CAChB,gBAAgB;CAChB,WAAW;CACX,mBAAmB;AACpB;;AAEA,sBAAsB;AACtB;CACC;EACC,eAAe;EACf,WAAW;EACX,gBAAgB;CACjB;;CAEA;EACC,WAAW;EACX,gBAAgB;CACjB;;CAEA;EACC,SAAS;CACV;AACD;;AAEA;CACC;EACC,eAAe;CAChB;;CAEA;EACC,QAAQ;CACT;AACD","sourcesContent":[".App-header {\r\n\tbackground-color: var(--third-bg-color);\r\n\theight: 10vh;\r\n\tdisplay: flex;\r\n\tflex-direction: row;\r\n\talign-items: center;\r\n\tjustify-content: space-between;\r\n\tfont-size: calc(2px + 2vmin);\r\n\tcolor: var(--main-text-color);\r\n\tbox-shadow: 0 2px 10px rgba(127, 204, 159, 0.1);\r\n\tpadding: 0 20px;\r\n\tposition: sticky;\r\n\ttop: 0;\r\n\tz-index: 100;\r\n}\r\n\r\n.header-left {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n}\r\n\r\n.header-right {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tgap: 16px;\r\n}\r\n\r\n.logo-link {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\ttext-decoration: none;\r\n\ttransition: opacity 0.3s;\r\n}\r\n\r\n.logo-link:hover {\r\n\topacity: 0.8;\r\n}\r\n\r\n.aegirLogo {\r\n\theight: 7vh;\r\n\tmin-height: 50px;\r\n\tmax-height: 80px;\r\n\twidth: auto;\r\n\tobject-fit: contain;\r\n}\r\n\r\n/* Mobile Responsive */\r\n@media (max-width: 768px) {\r\n\t.App-header {\r\n\t\tpadding: 0 15px;\r\n\t\theight: 8vh;\r\n\t\tmin-height: 60px;\r\n\t}\r\n\t\r\n\t.aegirLogo {\r\n\t\theight: 5vh;\r\n\t\tmin-height: 40px;\r\n\t}\r\n\t\r\n\t.header-right {\r\n\t\tgap: 12px;\r\n\t}\r\n}\r\n\r\n@media (max-width: 480px) {\r\n\t.App-header {\r\n\t\tpadding: 0 10px;\r\n\t}\r\n\t\r\n\t.header-right {\r\n\t\tgap: 8px;\r\n\t}\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
